export const UploadFileTypes = {
  IMAGE: 'image',
  VIDEO: 'video',
  VIDEO_TYPE: 'video',
};
